<template>
  <Datatable
    entity="customer_dispatch"
    :parameters="{branch: $route.query.branch}"
    :onRowClick="displayCustomer"
    :rowActions="[{text: 'datatable.display', method: displayCustomer}]">
  </Datatable>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";

  export default {
    name: "DispatchCustomers",

    components: { Datatable },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "customers.dispatch";
      this.$store.state.pageIcon = "/icon/user.svg";
    },

    methods: {
      displayCustomer(row) {
        this.$router.push(this.$router.buildContext("/dispatch-customer", {id: row.id}));
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>